import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ButtonBase from "@mui/material/ButtonBase";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { CSVLink } from "react-csv";
import AdminIcon from "./adminIcons";
import { ADMIN_BUTTON_SX, ADMIN_COLORS, ADMIN_FONT, ADMIN_ICON_SIZE, ADMIN_TYPE } from "./adminUi";
import { ADMIN_INPUT_SX } from "./adminForm";

var SEARCH_MAX = 100;
var SEARCH_WIDTH = 380;

/**
 * List toolbar shared by Manage New Joinee and Manage HR:
 * search (+ optional "Clear filters") on the left, Export CSV on the right.
 */
function AdminListToolbar(props) {
  var exportData = props.exportData || [];
  var searchLabel = props.searchPlaceholder || "Search Name, designation and email";

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "12px" }}>
      <TextField
        type="search"
        placeholder={searchLabel}
        value={props.search}
        onChange={function (e) {
          props.onSearchChange(e.target.value);
        }}
        inputProps={{ "aria-label": searchLabel, maxLength: SEARCH_MAX }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" sx={{ mr: 0 }}>
              <AdminIcon name="MagnifyingGlass" size={ADMIN_ICON_SIZE.action} sx={{ color: ADMIN_COLORS.labelMuted }} />
            </InputAdornment>
          ),
        }}
        sx={[ADMIN_INPUT_SX, { width: { xs: "100%", sm: SEARCH_WIDTH } }]}
      />
      {props.onClearFilters ? (
        <ButtonBase
          onClick={props.onClearFilters}
          sx={{
            fontFamily: ADMIN_FONT,
            fontSize: ADMIN_TYPE.button.fontSize,
            lineHeight: ADMIN_TYPE.button.lineHeight,
            color: ADMIN_COLORS.brand,
            borderRadius: "4px",
            px: "4px",
            "&:hover": { textDecoration: "underline" },
          }}
        >
          Clear filters
        </ButtonBase>
      ) : null}
      <Box sx={{ flex: 1 }} />
      <CSVLink
        data={exportData}
        filename={props.exportFilename}
        target="_blank"
        style={{ textDecoration: "none" }}
        onClick={function () {
          return exportData.length > 0;
        }}
      >
        <Button
          component="span"
          variant="outlined"
          disabled={!exportData.length}
          startIcon={<AdminIcon name="Download" size={ADMIN_ICON_SIZE.button} />}
          sx={[ADMIN_BUTTON_SX.outlined, ADMIN_BUTTON_SX.withStartIcon]}
        >
          Export CSV
        </Button>
      </CSVLink>
    </Box>
  );
}

export default AdminListToolbar;
